export const PAGE_ERROR_MAPPING:{[key:string]:string} = {
    "Manage Folder": "/edge/foldermanagement/error",
    "Saved Search": "/edge/foldermanagement/error",
    "Folder Management": "/edge/foldermanagement/error",
    "Dashboard Page": "/edge/dashboard/error",
}

export const DEFAULT_ERROR_PAGE = "/edge/dashboard/error";

